import { useEffect, useState } from "react";
import { ArrowLeftIcon, CheckIcon } from "lucide-react";
import { Link } from "react-router";

import { Column, Row, TopbarContainer, TopbarTitle } from "@/components";
import { NotificationsSettingsContent } from "@/components/notifications/NotificationsSettingsContent";
import { Button } from "@/components/ui/button";

import { useSetTitle } from "@/hooks/useSetTitle";
import { mixpanelUtils } from "@/lib/mixpanel/mixpanel";
import { MIXPANEL_SCREENS } from "@/lib/mixpanel/types";

export const NotificationsSettingsPage = () => {
  const [showSettingsSaved, setShowSettingsSaved] = useState(false);

  useSetTitle({
    title: "Notifications | Settings",
  });

  useEffect(() => {
    mixpanelUtils.trackScreenView(MIXPANEL_SCREENS.NOTIFICATIONS, {
      subScreenName: "Settings",
    });
  }, []);

  const handlePreferenceChange = () => {
    setShowSettingsSaved(true);
  };

  return (
    <Column className="h-svh">
      <TopbarContainer className="!border-slate-100">
        <TopbarTitle className="!text-slate-500">
          <Row className="items-center gap-2">
            <Button
              asChild
              className="h-auto gap-2 px-0 text-lg font-semibold text-slate-500 hover:bg-transparent hover:text-slate-900 hover:underline"
              variant="ghost"
            >
              <Link to="/notifications">
                <ArrowLeftIcon className="h-4 w-4" />
                Notifications
              </Link>
            </Button>
            <span>/</span>
            <span className="text-slate-700">Settings</span>
          </Row>
        </TopbarTitle>
        <Row className="items-center gap-2 text-sm font-medium text-slate-600">
          {showSettingsSaved ? (
            <>
              <CheckIcon className="h-4 w-4 text-green-600" />
              Settings Saved
            </>
          ) : null}
        </Row>
      </TopbarContainer>
      <NotificationsSettingsContent
        onPreferenceChange={handlePreferenceChange}
      />
    </Column>
  );
};
